import Icon from '@ant-design/icons';
import dayjs from 'dayjs';
import React from 'react';
import LockIcon from '~/assets/svg/icon-lock.svg?react';

function ClosedBanner({ merchantName, event }) {
  const formattedDate = dayjs(new Date(event.created_on)).format('DD/MM/YYYY');

  let text;
  if (event.actor_type === 'automatic') {
    text = `Conversation clôturée automatiquement le ${formattedDate}`;
  } else if (event.is_admin === true) {
    text = `Le SAV Label Emmaüs a clôturé cette conversation le ${formattedDate}`;
  } else {
    text = (
      <>
        <b>{merchantName}</b> a clôturé cette conversation le {formattedDate}
      </>
    );
  }

  return (
    <div className='self-center p-m rounded-sm bg-grey-medium text-white flex items-center gap-s'>
      <Icon className='text-white text-[24px]' component={LockIcon} />
      <p className='body1'>{text}</p>
    </div>
  );
}

export default ClosedBanner;
